// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2dGtv","detailsBorder":"styles_detailsBorder__2nKqP"};